
/* 其他部分不需要授权的页面，和E教学没啥关系，但是没有资源加新的项目了 */
import _import from './_import'

const Home = _import('other/Home')
// AIPT学生端学情树图
const StudentTreeChart = _import('other/student/StudentTreeChart')
const StudentStarChart = _import('other/student/StudentStarChart/index')
// E教学移动端登录页面
const Login = _import('other/login/index')
// 自适应推题验证
const Personality = _import('other/personality/index')

export default [

  {
    path: '/other',
    name: 'other',
    component: Home,
    children: [
      {
        path: 'studentTreeChart',
        name: 'studentTreeChart',
        component: StudentTreeChart,
        meta: {title: '学情树'}
      },
      {
        path: 'StudentStarChart',
        name: 'StudentStarChart',
        component: StudentStarChart,
        meta: {title: '星空图'}
      },
      {
        path: 'login',
        name: 'login',
        component: Login,
        meta: {title: '登录'}
      },
      {
        path: 'personality',
        name: 'personality',
        component: Personality,
        meta: {title: '个性化-推题验证'}
      }
    ]
  }
]
